(ns dre.pages.admin.usage.db)

(def init-db
  {:filters {:from nil
             :to nil
             :include-dre false
             :include-browser true
             :include-api false
             :client nil
             :username nil}
   :user-list {:response nil
                :state nil}
   :client-list {:response nil
                 :state nil}
   :events {:response nil
            :state nil
            :pagination {:limit 10
                         :offset 0
                         :current-page 1}}
   :top-users {:response nil
               :state nil}
   :top-clients {:response nil
                 :state nil}
   :selected-tab :events #_:top-clients #_:top-users})
